<template>
    <div class="image-holder" :class="{ cropped: data.crop.cropped }" v-on="$listeners">
        <span v-if="data.type == 'base'" class="height-control" :style="'padding-bottom:' + data.crop.height + '%'"></span>
        <img v-if="data.type == 'base'" :src="url" :style="{ top: data.crop.top + '%', left: data.crop.left + '%', width: data.crop.width + '%' }" alt="" />
        <div v-if="data.type != 'base' && data.type == 'phone-zoomed'" class="image-frame" :class="data.type">
            <img class="screen" ref="image" :src="url" :style="{ top: 34 - parseInt(data.pan) + '%' }" alt="" />
            <img
                class="frame"
                src="https://assets.procreate.art/handbook/frames/PocketHandbook-PhoneFrame.png"
                :style="{ top: 30 - parseInt(data.pan) + '%' }"
                alt=""
            />
        </div>
        <div v-if="data.type != 'base' && data.type != 'phone-zoomed'" class="image-frame" :class="data.type">
            <img class="screen" ref="image" :src="url" alt="" />
            <img class="frame" src="https://assets.procreate.art/handbook/frames/PocketHandbook-PhoneFrame.png" alt="" />
        </div>

        <div class="touch-points" aria-hidden="true">
            <ImageBit v-for="tp in data.tps" :key="tp.id" :image-data="tp"></ImageBit>
        </div>
        <div class="arrows" aria-hidden="true">
            <ImageBit v-for="arrow in data.arrows" :key="arrow.id" :image-data="arrow"></ImageBit>
        </div>
        <div class="hands" aria-hidden="true">
            <ImageBit v-for="hand in data.hands" :key="hand.id" :image-data="hand"></ImageBit>
        </div>
        <div class="tags" aria-hidden="true">
            <ImageBit v-for="tag in data.tags" :key="tag.id" :image-data="tag"></ImageBit>
        </div>
        <div class="pois" aria-hidden="true">
            <PoiBit v-for="(poi, index) in data.pois" :key="poi.id" :value-override="String(index + 1)" :id="poi.id" :image-data="poi"></PoiBit>
        </div>
    </div>
</template>

<script>
import ImageBit from "~/components/handbook/ImageBit";
import PoiBit from "~/components/handbook/PoiBit";

export default {
    components: { ImageBit, PoiBit },

    props: {
        id: {
            type: String,
            default() {
                return `bucket-${this._uid}`;
            },
        },
        image: String,
        controls: Object,
    },

    computed: {
        url: function () {
            let url = this.image.replace("https://images.procreate.art/", "");
            return `https://optimised.savage.si/format:jpg,width:1000/${url}`;
        },
    },

    data: function () {
        return {
            data: {
                crop: this.controls.crop,
                pan: this.controls.pan || "0",
                hands: this.controls.hands,
                arrows: this.controls.arrows,
                pois: this.controls.pois,
                tags: this.controls.tags,
                tps: this.controls.tps,
                type: this.controls.type || "base",
            },
        };
    },
};
</script>
